import React, { PropsWithChildren } from 'react'
import { ReactFC } from 'common/types/ReactFC'
import { generateSrcSet } from 'project/image-proxy-web'
import FeatureItem from 'components/FeatureItem'

const features = [
  {
    description:
      'We strictly comply with KYC/AML policies, enforced by a dedicated Compliance team. We are regulated as a Trust and Service Provider by the HMRC (AML no.12883542).',
    title: 'Regulatory compliance.',
  },
  {
    description:
      'A proven record of successful collaborations with prominent banks such as Tide, ANNA, and other fintech partners. Not to mention our accounting partnerships. All in all, we have securely serviced over 60,000 SMEs without incident.',
    title: 'Fintech partnership.',
  },
  {
    description:
      'We are audited regularly, maintain certifications, provide industry-standard protections (ICO no. ZA041914).',
    title: 'Data Protection.',
  },
  {
    description:
      'Our Cyber Essentials and Cyber Essentials Plus certifications highlight our commitment to cybersecurity.',
    title: 'Uncompromised Security.',
  },
  {
    description:
      'Ready to provide sample commercial agreement, T&Cs, Business Continuity Plan, Data protection policies, Customer Support SLA, Complaints Policy, Service Level Agreement, and Proof of ID and address document checklist.',
    title: 'Transparency & Accountability.',
  },
]

type GotYouCoveredCardType = {
  className?: string
}

const GotYouCoveredCard: ReactFC<PropsWithChildren<GotYouCoveredCardType>> = ({
  className = '',
}) => {
  return (
    <div className={`card`}>
      <div className='row px-2 px-lg-0'>
        <div className='col-12 mt-0 pt-8 pt-lg-11 g-3 g-lg-4 col-lg-6'>
          <div className='ps-4 ps-lg-20 pb-5 pb-lg-17 pe-4 pe-lg-0'>
            <h3 className='fs-fluid-24-32 fw-semibold mb-3 mb-lg-6'>
              You're covered
            </h3>

            <div className='d-flex flex-column gap-5 fs-fluid-16-20'>
              {features.map((feature) => (
                <FeatureItem
                  key={feature.title}
                  title={feature.title}
                  description={feature.description}
                />
              ))}
            </div>
          </div>
        </div>

        <div className='col-12 mt-0 col-lg-6 d-flex flex-column position-relative'>
          <img
            {...generateSrcSet('/images/new/robot-mail-preview.png', 678, 820)}
            alt='HaiRo™ mail service with robot mascot and phone displaying mail interface'
            className='rounded-img'
            loading='lazy'
            style={{
              objectFit: 'contain',
              maxWidth: '100%',
              position: 'absolute',
              right: 0,
              top: 0,
            }}
            height={820}
            width={678}
          />
        </div>
      </div>
    </div>
  )
}

export default GotYouCoveredCard
